import React, { useRef, useState } from 'react';
import { getDatabase, push, ref, runTransaction } from 'firebase/database';
import './AddCustomer.css';
import { useHistory } from 'react-router-dom';
import Navigation from '../../../navigation/Navigation';
import PageHeading from '../../../shared/pageHeading/PageHeading';
import TableSelector from '../../../shared/tableSelector/TableSelector';
import AlertManager from '../../../shared/AlertManager/AlertManager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';

const AddCustomer = () => {
	const [loading, setLoading] = useState(false);
	const [tableNo, setTableNo] = useState(null);
	const [alerts, setAlerts] = useState({
		visibility: false
	});
	const history = useHistory();
	const firstNameRef = useRef();
	const lastNameRef = useRef();
	const phoneNoRef = useRef();
	const emailRef = useRef();
	const handleAddCustomerSubmit = async () => {
		setLoading(true);
		try {
			const db = getDatabase();
			const tableRef = ref(db, '/tables/' + tableNo.toString());
			runTransaction(tableRef, table => {
				if (table) {
					setAlerts({
						visibility: true,
						message: 'Bordsnummer: ' + tableNo + ' är upptaget',
						type: 'error',
						duration: 'infinite'
					});
					return;
				} else {
					try {
						let customer = push(ref(db, 'users/'), {
							firstName: firstNameRef.current.value ? firstNameRef.current.value : 'null',
							lastName: lastNameRef.current.value ? lastNameRef.current.value : 'null',
							phoneNo: phoneNoRef.current.value ? phoneNoRef.current.value : 'null',
							email: emailRef.current.value ? emailRef.current.value : 'null'
						});
						table = customer.key;
						return table;
					} catch {
						setAlerts({
							visibility: true,
							message: 'Oops, något gick fel!',
							type: 'error',
							duration: 'infinite'
						});
						setLoading(false);
						return;
					}
				}
			});
			setLoading(false);
			history.push('/customers');
		} catch (error) {
			console.error('@AddCustomer-->', error);
			setAlerts({
				visibility: true,
				message: 'Oops, något gick fel!',
				type: 'error',
				duration: 'infinite'
			});
			setLoading(false);
		}
	};
	return (
		<>
			<Navigation />
			<div className='AppContents'>
				<div className='Container'>
					<PageHeading heading={'Lägg till kund'} />
					<AlertManager
						data={{
							alerts: alerts,
							setAlerts: setAlerts
						}}
					/>
					<section className='AddCustomer'>
						<div>
							<label>Förnamn</label>
							<input ref={firstNameRef} placeholder='Förnamn' />
						</div>
						<div>
							<label>Efternamn</label>
							<input ref={lastNameRef} placeholder='Efternamn' />
						</div>
						<div>
							<label>Telefon nummer</label>
							<input ref={phoneNoRef} placeholder='Telefon nummer' />
						</div>
						<div>
							<label>E-post</label>
							<input ref={emailRef} placeholder='E-post' />
						</div>
					</section>
					<TableSelector
						data={{
							setTableNo: setTableNo,
							tableNo: tableNo
						}}
					/>
					<section>
						<button disabled={loading} onClick={() => handleAddCustomerSubmit()}>
							<FontAwesomeIcon icon={faUserPlus} /> Lägg till
						</button>
					</section>
				</div>
			</div>
		</>
	);
};

export default AddCustomer;
